<div style="overflow: none; min-height: 100vh;" class="xl2:pt-[150px]   justify-center items-center">
  <div
    class="flex flex-col xl2:flex-row mx-auto max-w-6xl gap-8 justify-center px-6 md:flex xl:px-0  pt-[150px] xl2:pt-0">
    <div class="xl2:w-2/3 order-2 lg:order-1">
      <div *ngFor="let item of g; let i = index"
        class="justify-between mb-6 rounded-lg bg-white p-6 min-h-[200px] sm:flex sm:justify-start main_glass">
        <img [src]="getHost()+'/'+item.icon" [alt]="item.description || 'Product image'" class="w-full rounded-lg sm:w-40 object-contain" />
        <div class="sm:ml-4 sm:flex sm:w-full sm:justify-between">
          <div class="mt-5 sm:mt-0">
            <h2 class="text-lg font-bold text-gray-900 black-ops_one-regular">
              {{ item.description }}
            </h2>
            <p class="mt-1 text-xs text-gray-700">
              {{ item.warranty | uppercase }}
            </p>
            <p class="!text-[1.2em] newP !mb-0">{{ item.total }}</p>
            <p class="mt-1 text-xs text-gray-700">
              {{ item.unitPrice }} UNIT PRICE
            </p>
          </div>
          <div class="mt-4 flex justify-between sm:space-y-6 sm:mt-0 sm:block sm:space-x-6">
            <div class="flex items-center">
              <div class="p-4 flex flex-row gap-2 justify-between items-center">
                <button mat-mini-fab color="warn" [disabled]="item.quantity === 1" (click)="reduce(item!)"
                  aria-label="reduce quantity">
                  <img src="../../../assets/graphics/remove_24dp_FILL1_wght400_GRAD0_opsz24.svg" alt="Decrease quantity" />
                </button>
                <input readonly [(ngModel)]="item.quantity"
                  class="appearance-none text-center text-lg max-w-24 min-w-24 font-bold block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:border-orange-500"
                  id="qty" type="text" min="1" max="100" />
                <button mat-mini-fab color="warn" [disabled]="item.quantity === 100" (click)="increase(item!)"
                  aria-label="increase quantity">
                  <img src="../../../assets/graphics/add_24dp_FILL1_wght400_GRAD0_opsz24.svg" alt="Increase quantity" />
                </button>
              </div>
            </div>
            <div class="flex items-center justify-end">
              <button mat-icon-button color="warn" (click)="deleteItem(i)" aria-label="delete item">
                <img src="../../../assets/graphics/delete_24dp_FILL1_wght400_GRAD0_opsz24.svg" alt="Remove item" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="g.length === 0">
        <p>Browse through categories to find what your ❤️ wants</p>
      </div>
    </div>

    <div
      class="mt-6 h-full rounded-lg order-1 xl2:order-2 min-h-[200px] bg-white p-6 flex flex-col justify-between content-between md:mt-0 xl2:w-1/3 main_glass"
      style="position: sticky;">
      <div class="flex flex-row justify-end pb-4">
        <button [routerLink]="['/help/quotation-generation']" aria-label="Help - read how to use quotation generation"
          matTooltip="Help - read how to use quotation generation"
          class="border border-gray-500 hover:border-[#ff4d06] text-gray-500 h-[32px] w-[32px] rounded-full text-sm gap-2">
          ?
        </button>
      </div>

      <div class="flex justify-between">
        <p class="text-lg font-bold">Total</p>
        <div class="">
          <p class="mb-1 text-lg font-bold">{{ total | currency: "Rs." }}</p>
          <p class="text-sm text-gray-700">including VAT</p>
        </div>
      </div>
      <div class="flex flex-col w-full py-2 gap-2">
        <div class="w-full">
          <input type="text" id="first_name" [formControl]="name"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#ff4d06] focus:border-[#ff4d06] block w-full p-2.5 dark:bg-black dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
            placeholder="Your name (required)" required />
        </div>

        <div class="w-full">
          <input type="text" id="phone_number" [formControl]="phoneNumber"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#ff4d06] focus:border-[#ff4d06] block w-full p-2.5 dark:bg-black dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
            placeholder="Phone number (required)" required />
        </div>

        <div class="w-full">
          <input type="text" id="email" type="text" [formControl]="email"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#ff4d06] focus:border-[#ff4d06] block w-full p-2.5 dark:bg-black dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
            placeholder="Email (required)" required />
        </div>

        <small class="text-center">*by supplying above details, a quotation code will be generated to
          you for future reference.</small>
        <div class="flex flex-col justify-center items-center">
          <a routerLink="/privacy-policy" class="text-wrap"> PRIVACY POLICY</a>
          <a routerLink="/terms-and-conditions" class="text-wrap">TERMS AND CONDITIONS
          </a>
          <!-- {{ passKey }} -->
        </div>
      </div>

      <div class="pt-4 flex flex-col gap-4">

        <div *ngIf="total <=10000" class="  flex w-full  ">


          <button (click)="purchaseNow($event)" [disabled]="!formValid()" *ngIf="!preparing"  class="button-82-pushable  w-full flex" role="button">
            <span class="button-82-shadow w-full flex"></span>
            <span class="button-82-edge w-full flex"></span>
            <span class="button-82-front w-full text flex">
              <div class="flex flex-row gap-4 w-full justify-center">
                <span> BUY NOW </span>

              </div>
            </span>
          </button>


        </div>
        <div class="flex w-full ">
          <button matTooltip="Add to Cart, download the PDF later from the cart" (click)="downloadCart($event,false)"
            [disabled]="!formValid()" *ngIf="!preparing" aria-label="add to Cart button"
            class="button-black-88-pushable  w-full  flex" role="button">
            <span class="button-black-88-shadow w-full flex"></span>
            <span class="button-black-88-edge w-full flex"></span>
            <span class="button-black-88-front w-full text flex">
              <div class="flex flex-row gap-4 w-full justify-center" *ngIf="!preparing">
                <span> DOWNLOAD QUOTATION </span>

              </div>
              <div class="flex flex-row gap-4 w-full justify-center" *ngIf="preparing">
                PREPARING....
              </div>
            </span>
          </button>
        </div>


        <!-- <button (click)="downloadCart($event)" [disabled]="!formValid()" *ngIf="!preparing"
          aria-label="download quotation now"
          class="border w-full bg-yellow-300 text-black font-semibold hover:text-white py-4 px-4 hover:!bg-[#ff4d06] hover:border-[#ff4d06] rounded-lg flex items-center justify-center flex-col"
          [ngClass]="{ 'opacity-20': !formValid() }">
          <span *ngIf="!preparing">
            <span> DOWNLOAD QUOTATION&nbsp;&nbsp;&nbsp; </span>
          </span>

          <span *ngIf="preparing">PREPARING.... </span>
        </button> -->

        <!-- <button (click)="downloadCart($event)" [disabled]="!formValid()" *ngIf="!preparing"
          aria-label="download quotation now"
          class="border w-full bg-yellow-300 text-black font-semibold hover:text-white py-4 px-4 hover:!bg-[#ff4d06] hover:border-[#ff4d06] rounded-lg flex items-center justify-center flex-col"
          [ngClass]="{ 'opacity-20': !formValid() }">
          <span *ngIf="!preparing">
            <span> PURCHASE NOW&nbsp;&nbsp;&nbsp; </span>
          </span>

          <span *ngIf="preparing">PREPARING.... </span>
        </button> -->

        <span *ngIf="preparing"> PREPARING...</span>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>